export const timeline = [
  {
    id: 'debut-1',
    date: '10 février 2025',
    title: 'Première Conversation',
    description: 'Le début de tout. Notre première discussion qui a changé nos vies.',
    emoji: '💬',
    section: 'debuts'
  },
  {
    id: 'debut-2',
    date: '21 février 2025',
    title: 'La Rencontre',
    location: 'Bibliothèque du CAM',
    highlights: ['Poulet Rouge', 'Première poutine ensemble'],
    emoji: '📚',
    section: 'debuts'
  },
  {
    id: 'debut-3',
    date: '28 février 2025',
    title: 'Avant la Distance',
    description: 'Ton voyage aux Bahamas. La distance qui a testé notre connexion.',
    emoji: '✈️',
    section: 'debuts'
  },
  {
    id: 'integration-1',
    date: '23 mars 2025',
    title: 'Tu Entres dans Mon Monde',
    description: 'Tu rencontres ma famille et mes amis. Tu deviens partie de ma vie.',
    emoji: '👨‍👩‍👧‍👦',
    section: 'integration'
  },
  {
    id: 'integration-2',
    date: 'Avril 2025',
    title: 'Valeurs Partagées',
    location: 'Cabane à sucre',
    description: 'Nos valeurs alignées: foi, amour, égalité, humour.',
    emoji: '🍁',
    section: 'integration'
  },
  {
    id: 'chorus',
    date: '4 juin 2025',
    title: 'Le Moment Clé',
    description: 'On est officiellement ensemble. Le plus beau jour.',
    emoji: '💕',
    section: 'chorus',
    isHighlight: true
  },
  {
    id: 'ete-1',
    date: 'Été 2025',
    title: 'Notre Été',
    highlights: ['Croisière', 'Spectacle comédie', 'Bowling', 'Titanic'],
    emoji: '☀️',
    section: 'ete'
  },
  {
    id: 'ete-2',
    date: 'Été 2025',
    title: 'Moments Simples',
    highlights: ['Vieux-Port de Montréal', 'Mont-Royal'],
    description: 'Les moments simples sont les plus précieux.',
    emoji: '🌅',
    section: 'ete'
  },
  {
    id: 'automne-1',
    date: 'Automne 2025',
    title: "L'Automne & la Maturité",
    highlights: ['Cueillette de pommes', 'Brunchs du dimanche', 'Restaurants'],
    emoji: '🍂',
    section: 'automne'
  },
  {
    id: 'automne-2',
    date: '2025',
    title: 'Inside Jokes',
    description: '"Viand Boeuf" - Ces petits riens qui nous font rire.',
    emoji: '😂',
    section: 'automne'
  }
]

export const challenges = [
  {
    id: 'challenge-1',
    title: 'Les Hauts & les Bas',
    description: 'Comme toute relation, nous avons eu nos moments difficiles.',
    emoji: '📈'
  },
  {
    id: 'challenge-2',
    title: 'Tensions Familiales',
    description: 'Naviguer les dynamiques familiales ensemble.',
    emoji: '👨‍👩‍👧'
  },
  {
    id: 'challenge-3',
    title: 'Défis Personnels',
    description: 'Se soutenir dans nos défis individuels.',
    emoji: '💪'
  },
  {
    id: 'challenge-4',
    title: 'Croissance Spirituelle',
    description: 'Grandir ensemble dans notre foi.',
    emoji: '🙏'
  }
]

export const pillars = [
  {
    id: 'pillar-1',
    title: 'Communication',
    description: 'Toujours parler, toujours écouter.',
    emoji: '💬',
    color: 'from-primary-pink to-accent-pink'
  },
  {
    id: 'pillar-2',
    title: 'Prière',
    description: 'Notre fondation spirituelle.',
    emoji: '🙏',
    color: 'from-accent-pink to-accent-coral'
  },
  {
    id: 'pillar-3',
    title: 'Soutien',
    description: 'Être là, toujours.',
    emoji: '🤝',
    color: 'from-accent-coral to-primary-pink'
  }
]

export const futureGoals = [
  {
    id: 'goal-1',
    title: 'Plus de Prières',
    description: 'Continuer à grandir spirituellement ensemble.',
    emoji: '🙏'
  },
  {
    id: 'goal-2',
    title: 'Plus de Dates',
    description: 'Créer encore plus de souvenirs.',
    emoji: '💑'
  },
  {
    id: 'goal-3',
    title: 'Ta Maîtrise',
    description: 'Te soutenir dans tes études.',
    emoji: '🎓'
  },
  {
    id: 'goal-4',
    title: 'Nouvelles Voitures',
    description: 'Nos nouveaux jouets à venir!',
    emoji: '🚗'
  }
]
